import { fold } from 'fp-ts/Either';
import * as t from 'io-ts';
import { DecodeResponseError } from '../errors/DecodeResponseError';

export function decodeP<T, O, I>(
  decoder: t.Type<T, O, I>,
  input: I,
  errorBuilder?: (errors: any) => Error,
): Promise<T> {
  const result = decoder.decode(input);

  return fold(
    (e: any) => {
      console.error(e);
      const error = errorBuilder
        ? errorBuilder(e)
        : new DecodeResponseError(
            `Decode response from server error: ${JSON.stringify(input)}`,
          );

      return Promise.reject(error);
    },
    (data: any) => Promise.resolve(data),
  )(result);
}
